export const DISPLAYED_MESSAGE_DATA = 'DISPLAYED_MESSAGE_DATA';
export const GET_USER_SUGGESTION_SUCCESS = 'GET_USER_SUGGESTION_SUCCESS';
export const GET_USER_SUGGESTION_FAILURE = 'GET_USER_SUGGESTION_FAILURE';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const CLEAR_USER_SUGGESTION = 'CLEAR_USER_SUGGESTION';
export const SELECTED_USER_ID = 'SELECTED_USER_ID';
export const SELECTED_ROLE = 'SELECTED_ROLE';
export const SELECTED_USER_TYPE = 'SELECTED_USER_TYPE';

export default {
  [DISPLAYED_MESSAGE_DATA](state, { isResponseMessageVisible, displayName, statusCode, message }) {
    state.isResponseMessageVisible = isResponseMessageVisible;
    state.latestAssociationDisplayName = displayName;
    state.latestAssociationStatusCode = statusCode;
    state.latestAssociationMessage = message;
  },
  [GET_USER_SUGGESTION_SUCCESS](state, payload) {
    state.users = payload;
  },
  [GET_USER_SUGGESTION_FAILURE](state) {
    state.users = [];
  },
  [CLEAR_USER_SUGGESTION](state) {
    state.users = [];
  },
  [SELECTED_USER_ID](state, { selectedUserId, selectedDisplayName }) {
    state.selectedUserId = selectedUserId;
    state.selectedDisplayName = selectedDisplayName;
  },
  [SELECTED_ROLE](state, payload) {
    state.selectedRole = payload;
  },
  [CREATE_USER_SUCCESS](state, { displayName, statusCode, message }) {
    state.isResponseMessageVisible = true;
    state.latestAssociationDisplayName = displayName;
    state.latestAssociationStatusCode = statusCode;
    state.latestAssociationMessage = message;
    state.userType = 'new';
  },
  [CREATE_USER_FAILURE](state, { displayName, statusCode, message }) {
    state.isResponseMessageVisible = true;
    state.latestAssociationDisplayName = displayName;
    state.latestAssociationStatusCode = statusCode;
    state.latestAssociationMessage = message;
  },
  [SELECTED_USER_TYPE](state, payload) {
    state.userType = payload;
    switch (payload) {
      case 'new':
        state.isAddFormVisible = true;
        break;
      case 'existing':
        state.isAddFormVisible = false;
        break;
      default:
        break;
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/linkUser/linkUser.mutations.js